import React, { useState, useEffect, useRef } from 'react';
import { get } from '../../util/request';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { userInfo } from '../../redux/slice';
import Table from 'react-bootstrap/Table';
import { Pagination } from 'antd';
import { SortTypeSelect, SearchDatePickerField } from '../../components/common/form';
import Button from 'react-bootstrap/Button';
import FooterPagination from '../../components/common/pagination';
import NoDataBox from '../../components/page/noData';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

import './index.scss';
import Loading from '../../components/common/loading';
import ExitBanner from '../../components/page/exitBanner/index.js';

const SelectRole = () => {
  const { t, i18n } = useTranslation();
  // console.log('role')
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(userInfo);
  const filterBoxRef = useRef(null);
  const [personalListData, setPersonalListData] = useState({});
  //list data handle
  const [listData, setListData] = useState([]);
  const [pageNum, setPageNum] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  const [isSearchable, setIsSearchable] = useState(false);
  const sortOption = [
    { value: 'desc', label: t('Document date (New - Old)') },
    { value: 'asc', label: t('Document date (Old - New)') },
  ];
  const [sortType, setSortType] = useState(sortOption[0]);

  const [searchDate, setSearchDate] = useState(null);
  const [searchName, setSearchName] = useState(null);
  const [searchDocType, setsearchDocType] = useState(null);
  const [searchProjectCode, setSearchProjectCode] = useState(null);

  const [searchhandle, setSearchHandle] = useState(true);

  const [docTypeOption, setDocTypeOption] = useState([]);
  const [projectCodeOption, setProjectCodeOption] = useState([]);
  const [showFilterBox, setShowFilterBox] = useState(false);
  const [loading, setLoading] = useState(false);
  const options = [
    { value: '1', label: 'All' },
    { value: '2', label: 'All' },
    { value: '3', label: 'All' },
  ];

  const handleDownLoad = async (item) => {
    try {
      setLoading(true)
      let params = {
        deviceId: null,
        deviceModel: ' WEB',
        deviceToken: null,
        entry: 'WEB',
        isChina: false,
        accessToken: user.accessToken,
        userId: user.userId,
        // accessToken: "c89960648ae6224f2a45f055e1f7c3ee3e7b75024a67356825ed64d412a1b797",
        // userId: "61",
      };
      const data = await get('/appUser/documents/' + item.docNumber, params);
      if (data) {
        if (data.message) {
          var bytes = base64ToArrayBuffer(data.message);
          saveByteArray(item.productName + ' - ' + item.description, bytes);
        }
      }

    } catch (error) {
      console.log('error', error);
    } finally {
      setLoading(false)
    }
  };
  const substringFromEndUntilFirstSlash = (originalString) => {
    const slashIndex = originalString.lastIndexOf('/');
    if (slashIndex === -1) {
      // 如果字符串中没有找到 '/'，则返回原字符串或处理这种情况的备用值
      return originalString; // 或者 `null`, `''`, 等视具体需求而定
    }
    return originalString.slice(slashIndex + 1);
  }
  const handleDownLoadPassportNationalId = async (item) => {
    try {
      setLoading(true);
      let params = {
        deviceId: null,
        deviceModel: ' WEB',
        deviceToken: null,
        entry: 'WEB',
        isChina: false,
        accessToken: user.accessToken,
        userId: user.userId,
      };
      const data = await get('/appUser/documents/' + substringFromEndUntilFirstSlash(item), params);
      if (data) {
        if (data.message) {
          var bytes = base64ToArrayBuffer(data.message);
          saveByteArray(substringFromEndUntilFirstSlash(item), bytes);
        }
      }

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const base64ToArrayBuffer = (base64) => {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  };
  const saveByteArray = (reportName, byte) => {
    const link = document.createElement('a'); // 创建a标签
    const blob = new Blob([byte], {
      type: 'application/pdf',
    }); // response就是接口返回的文件流
    const objectUrl = URL.createObjectURL(blob);
    link.href = objectUrl;
    link.download = reportName;
    link.click(); // 下载文件
    URL.revokeObjectURL(objectUrl);
  };
  const handleSearchName = (e) => {
    setSearchName(e.target.value);
  };
  const handleClear = async () => {
    await setSearchName('');
    setSearchHandle(!searchhandle);
  };
  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      init();
    }
  }
  const getPersonal = async () => {
    let params = {
      accessToken: user.accessToken,
      userId: user.userId,
      sort: 'documentCreationDate,' + sortType.value,
      // date:searchDate
    };
    const data = await get('/appUser/documents/personal', params);
    if (data) {
      setPersonalListData(data);
    }
  };
  const init = async () => {
    let projectCode =
      searchProjectCode && searchProjectCode.length > 0
        ? searchProjectCode.map((obj) => obj.value).toString()
        : null;
    let docType =
      searchDocType && searchDocType.length > 0
        ? searchDocType.map((obj) => obj.value).toString()
        : null;
    let params = {
      productName: searchName,
      projectCodes: projectCode,
      docType: docType,
      offset: 'DESC',
      size: pageSize,
      page: pageNum > 0 ? pageNum - 1 : 0,
      userId: user.userId,
      deviceId: null,
      deviceModel: ' WEB',
      deviceToken: null,
      entry: 'WEB',
      isChina: false,
      accessToken: user.accessToken,
      userId: user.userId,
      sort: 'documentCreationDate,' + sortType.value,
      // date:searchDate
    };

    if (searchDate) {
      const year = searchDate.getFullYear();
      const month = String(searchDate.getMonth() + 1).padStart(2, '0'); // 补零至两位数
      const day = String(searchDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      params.date = formattedDate;
    }
    const data = await get('/appUser/documents', params);
    if (data) {
      if (data.content.length > 0) {
        for (let i = 0; i < data.content.length; i++) {
          var day = data.content[i].documentCreationDate.slice(8, 10)
          var year = data.content[i].documentCreationDate.slice(0, 4)
          var month = data.content[i].documentCreationDate.slice(5, 7)
          data.content[i].documentCreationDate = year + ' / ' + month + ' / ' + day
        }
      }
      setListData(data.content);
      setTotal(data.totalElements);
      // 关掉Filter Box
      setShowFilterBox(false);
    }
  };
  // const getDocOption = async () => {
  //   console.log(searchDate);

  //   let params = {
  //     accessToken: user.accessToken,
  //     userId: user.userId,
  //   };
  //   const data = await get('/option/docType', params);
  //   if (data) {
  //     let option = [];
  //     if (data.payload && data.payload.length > 0) {
  //       data.payload.map((item) => {
  //         option.push({ value: item.code, label: item.name });
  //       });
  //     }
  //     setDocTypeOption(option);
  //   }
  // };

  const getDocumentsTypesOption = async () => {
    //console.log(searchDate);

    let params = {
      accessToken: user.accessToken,
      userId: user.userId,
    };
    const data = await get('/appUser/documents/types', params);
    if (data) {
      let option = [];
      if (data.length > 0) {
        data.map((item) => {
          option.push({ value: item.code, label: item.name });
        });
      }
      setDocTypeOption(option);
    }
  };

  const docTypeMatch = (type) => {
    console.log(type)
    console.log(docTypeOption)
    for (var i = 0; i < docTypeOption.length; i++) {
      if (docTypeOption[i].value == type) {
        return docTypeOption[i].label;
      }
    }
  };

  //   const getProjectOption = async () => {
  //     let params = {
  //       accessToken: user.accessToken,
  //       userId: user.userId,
  //     };
  //     const data = await get('/appProducts/', params);
  //     if (data) {
  //       let option = [];
  //       if (data.length > 0) {
  //         data.map((item) => {
  //           option.push({ value: item.productNumber, label: item.productName });
  //         });
  //       }

  //       setProjectCodeOption(option);
  //     }
  // };
  const getProjectsOption = async () => {
    let params = {
      accessToken: user.accessToken,
      userId: user.userId,
    };
    const data = await get('/appUser/documents/projects', params);
    if (data) {
      let option = [];
      if (data.length > 0) {
        data.map((item) => {
          option.push({ value: item.code, label: item.nameEn });
        });
      }

      setProjectCodeOption(option);
    }
  }
  const handleMouseEnterFilterBox = (event) => {
    setShowFilterBox((prevState) => !prevState);
  };
  useEffect(() => {
    if (user.sfUserType === 'CL' && history.location.pathname.includes('preview')) {
      history.push({
        pathname: '/document'
      });
    }
    else if (user.sfUserType === 'IR') {
      history.push({
        pathname: '/preview/document'
      });
    }

    init();
    // getDocOption();
    getProjectsOption();
    getDocumentsTypesOption()
  }, []);
  useEffect(() => {
    init();
    getPersonal();
  }, [pageNum, pageSize]);
  useEffect(() => {
    init();
  }, [searchhandle]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterBoxRef.current && !filterBoxRef.current.contains(event.target)) {
        setShowFilterBox(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilterBox]);

  //  sort默认值多语言切换
  useEffect(() => {
    // 添加一个监听器，当语言变化时更新label
    const handleLanguageChange = () => {
      setSortType(prevSortType => ({
        ...prevSortType,
        label: i18n.t('Document date (New - Old)')
      }));
    };

    // 监听语言变化
    i18n.on('languageChanged', handleLanguageChange);

    // 清理函数，移除监听器
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n])

  const onChangePage = (pageNumber) => { };
  return (
    <div className="doc">
      {loading ? <Loading /> : null}
      <div className="main-box">
        <div className='row'>
          <ExitBanner isMissingProfileBannerOpen={true} isUpdateProfileButtonVisible={true} />
        </div>
        <div className="headline doc-wrapper">
          <div className='col-md-4 doc-title'><p>{t('My Document')}</p></div>
          <div className='col-md-8 doc-header'></div>
        </div>
        <div className="submit-box">
          <div className=" float-left searchControl">
            {/* <Form.Control
              type="text"
              placeholder="Keywords"
              id="searchInput"
            />{' '} */}

            <input
              className="form-control"
              type="text"
              placeholder={t("Keywords")} Keywords
              aria-label="search input"
              value={searchName}
              onChange={handleSearchName}
              onKeyDown={handleKeyDown}
            ></input>
          </div>
          <div className=" float-left ">
            <div>
              <button
                type="button"
                className="searchBtn btn btn-outline-theme"
                onClick={() => {
                  init();
                }}
              >
                {t('Search')}
              </button>
              <button
                type="button"
                className="linkBtn btn btn-link-theme "
                onClick={() => {
                  handleClear();
                }}
              >
                {t('Clear')}
              </button>
            </div>
          </div>
          <div className=" float-right ">
            <div className="filterSortby">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 22"
                fill="none"
              >
                <path
                  d="M4.2116 5.61C6.2316 8.2 9.9616 13 9.9616 13V19C9.9616 19.55 10.4116 20 10.9616 20H12.9616C13.5116 20 13.9616 19.55 13.9616 19V13C13.9616 13 17.6816 8.2 19.7016 5.61C20.2116 4.95 19.7416 4 18.9116 4H5.0016C4.1716 4 3.7016 4.95 4.2116 5.61Z"
                  fill="#003448"
                />
              </svg>
              <div>
                <button type="button" className="hoverFilter linkBtn btn btn-link-theme "
                  onClick={handleMouseEnterFilterBox}>
                  {t('Filter')}
                </button>
                {
                  showFilterBox ?
                    <div className="notification" ref={filterBoxRef}>
                      <div className="arrows"></div>
                      <div className="doc-noumenon">
                        <div className="field-group">
                          {t('MydocumentProject')}
                          <Select
                            isMulti
                            isSearchable={true}
                            options={projectCodeOption}
                            value={searchProjectCode}
                            placeholder={t('All')}
                            onChange={(data) => {
                              setSearchProjectCode(data);
                            }}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: 5,
                              colors: {
                                ...theme.colors,
                                primary25: '#F5F7FA',
                                primary: '#003448',
                              },
                            })}
                          />
                        </div>
                        <div className="field-group">
                          {t('Document Type')}
                          <Select
                            isMulti
                            isSearchable={true}
                            options={docTypeOption}
                            value={searchDocType}
                            placeholder={t('All')}
                            onChange={(data) => {
                              setsearchDocType(data);
                            }}
                            theme={(theme) => ({
                              ...theme,
                              borderRadius: 5,
                              colors: {
                                ...theme.colors,
                                primary25: '#F5F7FA',
                                primary: '#003448',
                              },
                            })}
                          />
                        </div>

                        <div className="btn-box">
                          <button
                            type="button"
                            style={{ float: 'right' }}
                            className="ResetBtn btn btn-outline-theme"
                            onClick={() => {
                              setSearchDate(null);
                              setSearchProjectCode(null);
                              setsearchDocType(null);
                              setSearchHandle(!searchhandle);
                            }}
                          >
                            {t('Reset')}
                          </button>
                          <button
                            type="button"
                            style={{ float: 'right' }}
                            className="ApplyBtn btn btn-outline-next"
                            onClick={init}
                          >
                            {t('Apply')}
                          </button>
                        </div>
                      </div>
                    </div> : null
                }
              </div>

              <div className="fly-mid"></div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.35766 16.7616H10.0979C10.1826 16.7616 10.252 16.7888 10.3064 16.843C10.3606 16.8977 10.3879 16.967 10.3879 17.052C10.3879 17.1241 10.3578 17.1969 10.2972 17.2692L7.40594 20.1606C7.34556 20.2148 7.27601 20.2419 7.19747 20.2419C7.12489 20.2419 7.05547 20.2148 6.98899 20.1606L4.08864 17.2601C3.9981 17.1634 3.97683 17.0577 4.02524 16.9428C4.07362 16.822 4.16429 16.7616 4.29712 16.7616H6.03737V4.29C6.03737 4.20549 6.06464 4.13597 6.11889 4.08152C6.17321 4.02714 6.24283 4 6.32737 4H8.06762C8.15229 4 8.22172 4.02727 8.27613 4.08156C8.33055 4.13587 8.35766 4.20549 8.35766 4.29003V16.7616ZM12.1283 6.32029H14.4485C14.5331 6.32029 14.6026 6.29314 14.6568 6.23876C14.7114 6.18435 14.7382 6.11492 14.7382 6.03029V4.29003C14.7382 4.20549 14.7113 4.13597 14.6568 4.08156C14.6026 4.02727 14.5331 4 14.4485 4H12.1283C12.0436 4 11.9742 4.02714 11.9198 4.08152C11.8655 4.13597 11.8383 4.20549 11.8383 4.29V6.03025C11.8383 6.11489 11.8654 6.18432 11.9198 6.23873C11.9742 6.29302 12.0436 6.32029 12.1283 6.32029ZM12.1282 10.961H16.1887C16.2733 10.961 16.3428 10.9338 16.397 10.8794C16.4515 10.825 16.4787 10.7556 16.4787 10.6709V8.93073C16.4787 8.84606 16.4515 8.77663 16.397 8.72225C16.3428 8.66794 16.2733 8.64067 16.1887 8.64067H12.1282C12.0435 8.64067 11.9741 8.66781 11.9197 8.72225C11.8654 8.77663 11.8382 8.84606 11.8382 8.93073V10.6709C11.8382 10.7556 11.8653 10.825 11.9197 10.8794C11.9741 10.9337 12.0435 10.961 12.1282 10.961ZM19.8777 18.0035C19.8232 17.9489 19.7538 17.9218 19.6692 17.9218H12.1283C12.0436 17.9218 11.9742 17.9489 11.9198 18.0035C11.8655 18.0578 11.8383 18.1273 11.8383 18.2118V19.952C11.8383 20.0369 11.8654 20.1061 11.9198 20.1606C11.9742 20.2149 12.0436 20.2421 12.1283 20.2421H19.6692C19.7538 20.2421 19.8232 20.2149 19.8777 20.1606C19.932 20.106 19.9591 20.0369 19.9591 19.952V18.2118C19.9592 18.1273 19.932 18.0578 19.8777 18.0035ZM17.929 15.6014H12.1282C12.0435 15.6014 11.9741 15.5743 11.9197 15.52C11.8653 15.4657 11.8382 15.3961 11.8382 15.3116V13.5712C11.8382 13.4867 11.8654 13.4172 11.9197 13.3629C11.9741 13.3085 12.0435 13.2814 12.1282 13.2814H17.929C18.0135 13.2814 18.083 13.3085 18.1376 13.3629C18.1918 13.4171 18.2189 13.4867 18.2189 13.5712V15.3116C18.2189 15.3961 18.1918 15.4657 18.1376 15.52C18.0831 15.5743 18.0135 15.6014 17.929 15.6014Z"
                  fill="#003448"
                />
              </svg>
              <div>
                <button type="button" className="hoverFilter linkBtn btn btn-link-theme">
                  {t('Sort By')}
                </button>
                <div className="notification sort-by-noti">
                  <div className="arrows"></div>
                  <div className="noumenon">
                    <span>{t('Sort By')} </span>
                    <SortTypeSelect value={sortType} setValue={setSortType} sortOption={sortOption}></SortTypeSelect>
                    <div className="btn-box">
                      <button
                        type="button"
                        style={{ float: 'right' }}
                        className="ResetBtn btn btn-outline-theme"
                        onClick={() => {
                          setSortType(sortOption[0]);
                          setSearchHandle(!searchhandle);
                        }}
                      >
                        {t("Reset")}
                      </button>
                      <button
                        type="button"
                        style={{ float: 'right', marginRight: '10px' }}
                        className="ApplyBtn btn btn-outline-next"
                        onClick={init}
                      >
                        {t("Apply")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {personalListData.passportUpdateTime != '' ||
          personalListData.nationalIdUpdateTime != '' ? (
          <div className="headline">
            <p>{t("Personal Information")}</p>
          </div>
        ) : (
          <></>
        )}
        <div className="container">
          {listData && listData.length > 0 ? (
            <div>
              <div className="mobile-box">
                <div className="mobile-left"></div>
                <div className="mobile-right"></div>
              </div>
              <Table className="table-border  align-middle">
                <tbody>
                  {personalListData.nationalIdUpdateTime &&
                    personalListData.nationalIdUpdateTime != '' ? (
                    <tr>
                      <td>National ID</td>
                      <td>{personalListData.nationalIdUpdateTime}</td>
                      <td>
                        <div onClick={() => handleDownLoadPassportNationalId(personalListData.nationalIdPath)}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            className="download"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12.4167 4C12.7964 4 13.1102 4.28215 13.1598 4.64823L13.1667 4.75V13.9385L16.553 10.553C16.8193 10.2867 17.2359 10.2625 17.5295 10.4804L17.6137 10.553C17.8799 10.8193 17.9041 11.2359 17.6863 11.5295L17.6137 11.6137L12.947 16.2803C12.6807 16.5466 12.2641 16.5708 11.9705 16.3529L11.8863 16.2803L7.21967 11.6137C6.92678 11.3208 6.92678 10.8459 7.21967 10.553C7.48594 10.2867 7.9026 10.2625 8.19621 10.4804L8.28033 10.553L11.6667 13.9396V4.75C11.6667 4.33579 12.0025 4 12.4167 4ZM19.8265 17.3149C19.7768 16.9488 19.463 16.6667 19.0833 16.6667L18.9816 16.6735C18.6155 16.7232 18.3333 17.037 18.3333 17.4167L18.333 18H6.5V17.4167L6.49315 17.3149C6.44349 16.9488 6.1297 16.6667 5.75 16.6667C5.33579 16.6667 5 17.0025 5 17.4167V18.75L5.00685 18.8518C5.05651 19.2178 5.3703 19.5 5.75 19.5H19.0833L19.1851 19.4932C19.5512 19.4435 19.8333 19.1297 19.8333 18.75V17.4167L19.8265 17.3149Z"
                              fill="#003448"
                            />
                          </svg>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <></>
                  )}

                  {personalListData.passportUpdateTime &&
                    personalListData.passportUpdateTime != '' ? (
                    <tr>
                      <td>Passport</td>
                      <td>{personalListData.passportUpdateTime}</td>
                      <td>
                        <div onClick={() => handleDownLoadPassportNationalId(personalListData.passportPath)}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            className="download"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12.4167 4C12.7964 4 13.1102 4.28215 13.1598 4.64823L13.1667 4.75V13.9385L16.553 10.553C16.8193 10.2867 17.2359 10.2625 17.5295 10.4804L17.6137 10.553C17.8799 10.8193 17.9041 11.2359 17.6863 11.5295L17.6137 11.6137L12.947 16.2803C12.6807 16.5466 12.2641 16.5708 11.9705 16.3529L11.8863 16.2803L7.21967 11.6137C6.92678 11.3208 6.92678 10.8459 7.21967 10.553C7.48594 10.2867 7.9026 10.2625 8.19621 10.4804L8.28033 10.553L11.6667 13.9396V4.75C11.6667 4.33579 12.0025 4 12.4167 4ZM19.8265 17.3149C19.7768 16.9488 19.463 16.6667 19.0833 16.6667L18.9816 16.6735C18.6155 16.7232 18.3333 17.037 18.3333 17.4167L18.333 18H6.5V17.4167L6.49315 17.3149C6.44349 16.9488 6.1297 16.6667 5.75 16.6667C5.33579 16.6667 5 17.0025 5 17.4167V18.75L5.00685 18.8518C5.05651 19.2178 5.3703 19.5 5.75 19.5H19.0833L19.1851 19.4932C19.5512 19.4435 19.8333 19.1297 19.8333 18.75V17.4167L19.8265 17.3149Z"
                              fill="#003448"
                            />
                          </svg>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <></>
                  )}
                </tbody>
              </Table>
            </div>
          ) : (
            <NoDataBox msg={''} />
          )}
        </div>
        <div className="headline">
          <p>{t('Project')}</p>
        </div>
        <div className=" container table-body">
          {listData && listData.length > 0 ? (
            <div>
              {/* mobile */}
              <div className="mobile-box">
                {
                  listData.map((item) => (
                    <>
                      {
                        <div className="moblie-list">
                          <div className="mobile-item">
                            <div className="moblie-list-title">{t('Project Name')}</div>
                            <div className="moblie-list-name">{item.productName}</div>
                          </div>
                          <div className="mobile-item">
                            <div className="moblie-list-title">{t('Document Type')}</div>
                            <div className="moblie-list-name">{item.description}</div>
                          </div>
                          <div className="mobile-item">
                            <div className="moblie-list-title">{t('Land Units')}</div>
                            <div className="moblie-list-name">{item.landUnits}</div>
                          </div>
                          <div className="mobile-item">
                            <div className="moblie-list-title">{t('Document Date')}</div>
                            <div className="moblie-list-name">{item.documentCreationDate}</div>
                          </div>
                          <div className="w-full">
                            <div className='download' onClick={() => handleDownLoad(item)}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M12.4167 4C12.7964 4 13.1102 4.28215 13.1598 4.64823L13.1667 4.75V13.9385L16.553 10.553C16.8193 10.2867 17.2359 10.2625 17.5295 10.4804L17.6137 10.553C17.8799 10.8193 17.9041 11.2359 17.6863 11.5295L17.6137 11.6137L12.947 16.2803C12.6807 16.5466 12.2641 16.5708 11.9705 16.3529L11.8863 16.2803L7.21967 11.6137C6.92678 11.3208 6.92678 10.8459 7.21967 10.553C7.48594 10.2867 7.9026 10.2625 8.19621 10.4804L8.28033 10.553L11.6667 13.9396V4.75C11.6667 4.33579 12.0025 4 12.4167 4ZM19.8265 17.3149C19.7768 16.9488 19.463 16.6667 19.0833 16.6667L18.9816 16.6735C18.6155 16.7232 18.3333 17.037 18.3333 17.4167L18.333 18H6.5V17.4167L6.49315 17.3149C6.44349 16.9488 6.1297 16.6667 5.75 16.6667C5.33579 16.6667 5 17.0025 5 17.4167V18.75L5.00685 18.8518C5.05651 19.2178 5.3703 19.5 5.75 19.5H19.0833L19.1851 19.4932C19.5512 19.4435 19.8333 19.1297 19.8333 18.75V17.4167L19.8265 17.3149Z"
                                  fill="#5582A0"
                                />
                              </svg>
                              <span className="download-text">Download</span>
                            </div>
                          </div>
                        </div>
                      }
                    </>
                  ))
                }
              </div>
              {/* desktop */}
              <Table className="table-border  align-middle mobile-hiden">
                <thead>
                  <tr className="align-middle">
                    <th>{t('Project Name')}</th>
                    <th>{t('Document Type')}</th>
                    {/* <th>{t('Description')}</th> */}
                    <th>{t('Land Units')}</th>
                    <th>{t('Document Date')}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {listData.map((item) => {
                    return (
                      <tr>
                        <td>{item.productName}</td>
                        {/* <td>{docTypeMatch(item.docType)}</td> */}
                        <td>{item.description}</td>
                        <td>{item.landUnits}</td>
                        <td>{item.documentCreationDate}</td>
                        <td>
                          <div className='download' onClick={() => handleDownLoad(item)}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              className='download-button'
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12.4167 4C12.7964 4 13.1102 4.28215 13.1598 4.64823L13.1667 4.75V13.9385L16.553 10.553C16.8193 10.2867 17.2359 10.2625 17.5295 10.4804L17.6137 10.553C17.8799 10.8193 17.9041 11.2359 17.6863 11.5295L17.6137 11.6137L12.947 16.2803C12.6807 16.5466 12.2641 16.5708 11.9705 16.3529L11.8863 16.2803L7.21967 11.6137C6.92678 11.3208 6.92678 10.8459 7.21967 10.553C7.48594 10.2867 7.9026 10.2625 8.19621 10.4804L8.28033 10.553L11.6667 13.9396V4.75C11.6667 4.33579 12.0025 4 12.4167 4ZM19.8265 17.3149C19.7768 16.9488 19.463 16.6667 19.0833 16.6667L18.9816 16.6735C18.6155 16.7232 18.3333 17.037 18.3333 17.4167L18.333 18H6.5V17.4167L6.49315 17.3149C6.44349 16.9488 6.1297 16.6667 5.75 16.6667C5.33579 16.6667 5 17.0025 5 17.4167V18.75L5.00685 18.8518C5.05651 19.2178 5.3703 19.5 5.75 19.5H19.0833L19.1851 19.4932C19.5512 19.4435 19.8333 19.1297 19.8333 18.75V17.4167L19.8265 17.3149Z"
                                fill="#003448"
                              />
                            </svg>
                            {t('Download')}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Pagination
                  total={total}
                  showSizeChanger
                  showQuickJumper
                  pageSize={pageSize}
                  pageSizeOptions={[10, 20, 50, 100]}
                  onChange={(page, pageSize) => {
                    setPageNum(page);
                    // setPageSize(pageSize);
                  }}
                  onShowSizeChange={(current, size) => {
                    setPageSize(size);
                  }}
                  showTotal={(total) => `${t("Total")} ${total} ${t("items")}`}
                />
              </div>
            </div>
          ) : (
            <NoDataBox msg={''} />
          )}
          {/* <div className='container'>
                <div >
                  <FooterPagination pageNum={pageNum} pageSize={pageSize}></FooterPagination>
                </div>
              </div> */}
        </div>
      </div>
    </div>
  );
};
export default SelectRole;
